import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { apiGetPersonnes } from "../../../api/ApiPersonnes";
import { apiGetProcesses } from "../../../api/ApiProcess";
import { apiGetAllContribByUsersByEspaces } from "../../../api/ApiColidee";
import { apiGetMarques } from "../../../api/ApiMarque";
import { Image } from "react-bootstrap";
import ComponentTitleAndSousTitle from "../../layout/ComponentTitleAndSousTitle";

const BlocStories = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [allStories, setAllStories] = useState([]);

  useEffect(() => {
    recupDatas();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupDatas = async () => {
    const resMarques = await apiGetMarques(ReduxInstance._id);
    let searchMarquePinned = false;
    let personnesStories = [];

    if (resMarques.data) {
      searchMarquePinned = resMarques.data.filter((item) => item.pinned === true)[0];
    }

    const resPersonnes = await apiGetPersonnes(ReduxInstance._id);
    if (resPersonnes) {
      if (searchMarquePinned) {
        personnesStories = resPersonnes.data.filter(
          (item) => item.marque === searchMarquePinned._id
        );
      } else {
        personnesStories = resPersonnes.data;
      }
      recupAllContributionsForUsersOnAllEspaces(personnesStories);
    }
  };

  const recupAllContributionsForUsersOnAllEspaces = async (personnesArray) => {
    const myForm = new FormData();

    personnesArray.forEach((element) => {
      myForm.append("email[]", element.email);
    });

    var espacesSouhaites = [];
    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces))
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);

    if (espacesSouhaites.length) {
      myForm.append("espacesSouhaites", espacesSouhaites.join(","));
      const resAllStories = await apiGetAllContribByUsersByEspaces(ReduxToken, myForm);

      if (resAllStories.data) {
        personnesArray.forEach((element) => {
          let personneFound = resAllStories.data.findIndex(function (personneColidee) {
            if (personneColidee.email === element.email) {
              return true;
            }
            return false;
          });
        });

        setAllStories(resAllStories.data);
      } else {
        console.log("error");
      }
    }
  };

  return (
    <div className="hackHomeEthicsTransparent">
      <ComponentTitleAndSousTitle title={t("public.pageHome.titleBloc0")} />
      <div className="containerStories">
        {allStories.map((item, index) => (
          <a
            href={process.env.REACT_APP_URL_COLIDEE + "profile/" + item.id_Colideur}
            target="_blank"
            rel="noreferrer"
            key={index}
            className="p-2 m-1 d-flex flex-column text-center"
          >
            <Image
              className="p-1 m-1"
              src={
                item.profile_pic
                  ? item.profile_pic
                  : process.env.REACT_APP_URL_COLIDEE + "img/medaillonuser.jpg"
              }
            />
            <div className="storiesIdentities">
              {item.prenom}
              <br />
              <span className="fw-bold">{item.nom}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default BlocStories;
